export default Object.freeze({
  /// ---------------------------- Menu Bar ------------------------- 
  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matriz",
  OSCILLOSCOPE: "Osciloscopio",
  BAR_GRAPH: "Gráfico de barras",
  REPORT: "Informe",
  INFOS: "Agenda",
  RESUME: "Resumen",
  LOG: "Log",
  CONFIG: "Configuraciones",

  SAVE: "Guardar",
  REMOVE: "Eliminar",

  // ---------------------------- Live List ----------------------------
  TIME_ON: "Tiempo de análisis: ",

  GOOD_STRING: "Bueno",
  ATTENTION_STRING: "Atención",
  BAD_STRING: "Malo",
  NO_SIGNAL_STRING: "Sin señal",
  UNKNOWN_STRING: "Desconocido",

  REASON: "\nMotivo: ",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección o señal",

  ADDRESSES: "Direcciones",
  ADDRESS: "Dirección",
  AMPLITUDE: "Amplitud",
  AMPLITUDE_PRE: "Amplitud del preámbulo",
  MEAN_AMPLITUDE: "Amplitud media",
  MEAN_AMPLITUDE_N: "Amplitud\nmedia",
  MIN_AMPLITUDE: "Amplitud mínima",
  MIN_AMPLITUDE_N: "Amplitud\nmínima",
  MAX_AMPLITUDE: "Sobreimpulso",
  NOISE: "Ruido",
  SIGNAL: "Señal",
  RATIO: "Relación",
  NETWORK_TAG: "Tag del segmento",
  IS_IN_SEGMENT: "¿Pertenece al\nsegmento?",
  IS_IN_SEGMENT_1: "Pertenece al",
  IS_IN_SEGMENT_2: "¿Segmento?",
  IS_IN_SEGMENT_DP: "Pertenece al segmento: ",
  IS_IN_SEGMENT_QUESTION: "¿Pertenece al segmento?",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_1: "Indica si el dispositivo pertenece al mismo segmento que este TS Scope DP.",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_2: "Esta opción debe ajustarse manualmente para cada dispositivo en la pantalla de configuraciones.",

  MIN_AMPLITUDE_1: "Amplitud",
  MIN_AMPLITUDE_2: "mínima",

  MEAN_AMPLITUDE_1: "Amplitud",
  MEAN_AMPLITUDE_2: "media",

  RESPONSE_TIME_1: "Tiempo",
  RESPONSE_TIME_2: "respuesta",
  CURRENT: "actual",
  MINIMUM: "mínimo",
  MAXIMUM: "máximo",

  RESPONSE_TIME: "Tiempo de\nrespuesta\nactual",
  MIN_RESPONSE_TIME: "Tiempo de\nrespuesta\nmínimo",
  MAX_RESPONSE_TIME: "Tiempo de\nrespuesta\nmáximo",

  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "Esta columna es un indicador de problemas en el canal A, cable verde, tales como:",
  CHANNEL_B_PROBLEM: "Esta columna es un indicador de problemas en el canal B, cable rojo, tales como:",
  MASTERS: "Maestros",
  SLAVES: "Esclavos",
  AMPLITUDE_IDLE: "Tensión en idle ",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",

  NETWORK_DATA: "Datos de la red",

  MODAL_TITLE: "Formas de onda características",

  TURNED_ON: "Encendida",
  TURNED_OFF: "Apagada",

  ANALYSIS_ERROR: "Se produjo un error al cambiar el estado del análisis",

  ANALYSIS: "Análisis",
  ANALYZER: "TS Scope DP ",

  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "TS Scope DP no encontrado; por favor, conéctelo al computador.",
  INVERTED_AB: "Los cables A y B están invertidos.",
  MONGO_OFF: "Error en la base de datos; cierre el programa y ábralo nuevamente. Si el error persiste, haga clic en el botón de abajo.",
  PICO_NOT_FOUND: "El TS Scope DP está desconectado. Después de reconectarlo, es necesario reiniciar el programa.",
  MONGO_REPAIR_SUCCESS: "¡Error reparado con éxito! Por favor, cierre el programa y ábralo nuevamente para que los cambios tengan efecto.",
  MONGO_REPAIR_ERROR: "No fue posible solucionar el problema. Por favor, póngase en contacto para recibir soporte.",
  INIT_PICO_NOT_FOUND_PLAY: "Error al iniciar el TS Scope DP. Por favor, desconéctelo de su computador, conéctelo nuevamente y reinicie el programa. Si el error persiste, reinicie el computador e inténtelo nuevamente.",

  REPAIR: "Reparar",
  LOADING_ANALYZER: "Iniciando TS Scope DP; por favor, espere.",

  NO_DP_ACTIVE_NETWORK: "El TS Scope DP no encontró una red activa; asegúrese de que esté conectado correctamente a una red PROFIBUS DP e inténtelo nuevamente.",

  INVALID_SERIAL: "El número de serie no corresponde a este TS Scope DP. Por favor, reinstale el programa con un número de serie válido.",
  INVERTED_AB_POPUP: "Los cables A y B están invertidos.\nPor favor, corrija la inversión de los cables y presione Play nuevamente.",

  MONGO_OFF_POPUP: "Error al inicializar la base de datos; haga clic en el botón de abajo para reparar el problema.",

  MEAN_AMPLITUDE_DESC: "Valor de amplitud medido entre el promedio de los puntos en nivel lógico alto y el promedio de los puntos en nivel lógico bajo, como ilustra la figura de abajo.",
  MEAN_AMPLITUDE_DESC_2: "La amplitud media alta es un indicativo de falta de terminadores. Cuando está baja, indica: resistencia en las conexiones; exceso de terminadores; cables prensados; cables aplastados o doblados, etc.",
  AMPLITUDE_MIN_DESC: "Valor de amplitud entre el menor punto de la forma de onda en nivel lógico alto y el mayor punto en nivel lógico bajo, como ilustra la figura de abajo.",
  AMPLITUDE_MIN_DESC_2: "Una gran diferencia entre la amplitud media y la mínima indica: reflexión (terminadores); cable largo; ruido; humedad en el bus, etc.",
  OVERSHOOTING_DESC: "Valor de amplitud entre el valor medio de la forma de onda en nivel lógico alto y el mayor punto en nivel lógico alto, como ilustra la figura de abajo.",
  OVERSHOOTING_DESC_2: "Indica: falta de terminadores; conexiones en medio del bus; derivaciones, etc.",
  RATIO_DESC_1: "Relación entre los valores de amplitud mínima y amplitud media, con el objetivo de evidenciar la degradación de la señal.",
  RATIO_DESC_2: "Cuanto más cerca de 1, mejor; y cuanto más cerca de 0 (cero), peor será la calidad de la señal.",
  RATIO_FOMULA: "Relación = Amp. mínima / Amp. media",

  IDLE_DESCRIPTION: " Período en que la red está ociosa, es decir, el período entre una pregunta del maestro y la respuesta del esclavo, o entre paquetes del maestro hacia sí mismo. La tensión ideal del idle es de 1V; valores diferentes indican problemas en la red.",

  MONITOR_IP_NOT_FOUND: "IP del monitor no encontrada",

  CHANNEL_DESCRIPTION_1: "Cortocircuito;",
  CHANNEL_DESCRIPTION_2: "Borne flojo;",
  CHANNEL_DESCRIPTION_3: "Cable roto;",
  CHANNEL_DESCRIPTION_4: "U otro problema que dañe la señal de comunicación.",

  SIGNAL_QUALITY: "Calidad de la señal",
  SIGNAL_QUALITY_DESCRIPTION_1: "En la columna “Señal” siempre se considera el peor caso, para amplitud media y mínima.",

  GOOD: "Bueno",
  GOOD_DESCRIPTION_1: "• Amplitud media de 4 a 7 V",
  GOOD_DESCRIPTION_2: ". ¡Señal con buena amplitud!",

  ATTENTION: "Atención - Acción preventiva",
  ATTENTION_DESCRIPTION_1: "• Amplitud media de 7 a 8 V",
  ATTENTION_DESCRIPTION_2: ". Puede indicar falta de terminadores.",
  ATTENTION_DESCRIPTION_3: "• Amplitud media de 3 a 4 V",
  ATTENTION_DESCRIPTION_4: ". Puede indicar resistencia en el bus, demasiados terminadores, problemas de conexión, bornes flojos, problema en esclavo, etc.",

  BAD: "Malo - Acción correctiva",

  BAD_DESCRIPTION_1: "• Amplitud media menor que 3 V",
  BAD_DESCRIPTION_2: " o mayor que 8 V",
  BAD_DESCRIPTION_3: ", puede causar pérdida de paquetes PROFIBUS.",
  BAD_DESCRIPTION_4: "• Amplitud mínima menor que 3 V",
  BAD_DESCRIPTION_5: " puede causar pérdida de paquetes PROFIBUS.",

  LIGHT_TONES: "Tonos claros",
  LIGHT_TONES_DESCRIPTION: "• El TS Monitor PROFIBUS PRO no está encontrando respuesta del esclavo; por lo tanto, el software mantiene las mediciones de la última captura y deja el tono claro indicando que no está actualizando los datos.",


  IDLE: "Idle:",
  TENSAO_IDLE_POPUP_1: "Si la tensión en idle es menor que 0,6 V, el valor se resaltará en naranja.",
  TENSAO_IDLE_POPUP_2: "Solo aparecerán aquí las tensiones en idle de los canales activos. Para cambiar qué canales están activos en este momento, vaya a la sección 'CANALES ACTIVOS' en la pantalla de configuraciones.",
  PS: "OBS",

  YEAR: " año",
  MONTH: " mes",
  MONTHS: " meses",
  DAY: " día",
  HOUR: " hora",
  MINUTE: " minuto",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Gráfico",
  A_AND_B: "A y B",
  B_A: "B - A",
  WAVE_FORM: "Forma de onda",
  AMPLITUDE_A: "Amplitud A",
  AMPLITUDE_B: "Amplitud B",
  ADDRESS_DP: "Dirección: ",
  WAVE_A: "Señal A",
  WAVE_B: "Señal B",
  WAVE_B_A: "Señal B - A",
  WAVE_PA: "Señal DP",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",

  TIME_NS: "Tiempo (ns)",
  TIME_US: "Tiempo (μs)",
  TIME_MS: "Tiempo (ms)",
  TIME_S: "Tiempo (s)",

  AMPLITUDE_PLACEHOLDER: "0.0 V",
  TIME_INTERVAL_PLACEHOLDER: "0.0",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tiempo",
  CONTROLS_POPUP_TEXT: "Después de presionar PLAY, la forma de onda se actualiza aproximadamente cada 200 milisegundos.",
  CONTROLS_POPUP_TEXT_2: "Para liberar los controles es necesario seleccionar la visualización manual y elegir un dispositivo.",

  SIZE: "Tamaño ",
  VISUALIZATION: "Visualización",
  AUTOMATIC: "Automática",
  MANUAL: "Manual",

  STD_WAVE_FORM: "Forma de onda estándar",
  LONG_CABLE_WAVE_FORM: "Forma de onda típica de cable largo",
  EXCESS_TERMINATIOR_WAVE_FORM: "Forma de onda típica de exceso de terminador",
  NO_SLAVE_WAVE_FORM: "Forma de onda típica de ausencia de esclavo (dispositivos desconectados)",
  REFLECTION_WAVE_FORM: "Forma de onda típica con reflexión",
  NO_TERMINATOR_WAVE_FORM: "Forma de onda típica de falta de terminador",
  FOR_MORE_INFO_DP: "Para obtener información adicional, consulte a Toledo & Souza o las directrices de PROFIBUS International. Cabe destacar que los eventos demostrados pueden ocurrir en conjunto, lo que cambia los patrones demostrados.",
  FEW_TERMINATOR_WAVE_FORM: "Forma de onda típica de poco terminador",

  WAVE_SIZE_DESC_1: "El TS Scope DP ya muestrea el frame de dos modos: con solo 1 Byte o con 3 Bytes, de modo que aquí podemos visualizar con mayor zoom en 1 Byte o con menor zoom en 3 Bytes.",
  WAVE_SIZE_DESC_2: "Existe una excepción: el frame “E5” – short acknowledgement – solo tiene 1 Byte, siempre.",
  WAVE_SIZE_DESC_3: "A continuación, un ejemplo en un frame con más de 1 y 3 Bytes.",

  TS_SCOPE_NOT_FINDING_ANSWER: "El TS Scope DP no está encontrando respuesta del esclavo; por lo tanto, los datos están desactualizados. La forma de onda de abajo es la última capturada por el sistema.",

  TIME_DP: "Tiempo: ",
  PS_1: "Obs. 1:",
  PS_2: "Obs. 2:",
  PS_3: "Obs. 3:",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Clasificar por",
  AMPLITUDE_ASC: "Amplitud creciente",
  AMPLITUDE_DESC: "Amplitud decreciente",
  ADDRESS_ASC: "Dirección creciente",
  VOLTAGE_V: "Tensión (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Tensión (V)",
  VOLTAGE_MV: "Tensión (mV)",
  VOLTAGE_MV_PEAK_TO_PEAK: "Tensión (mV)",
  ORDER: "Ordenación",
  REFRESH_DATA: "Actualizar datos",
  LOADING: "Cargando",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_ADDRESS_OR_TYPE: "Por favor, escriba un tipo de evento válido.",
  BEFORE_MONITOR_INIT_STR: "Anterior a la última inicialización",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por tipo de evento",
  LOG_WAITING: "Cargando datos del log",
  TYPE: "Tipo",

  TERMINATION_OFF_LOG_DESCRIPTION: "El TS Expert detectó una posible falta de terminador en la red.",
  NO_POWER_SUPPLY_LOG_DESCRIPTION: "El TS Expert detectó posible falta de alimentación en el terminador.",
  HIGH_RESISTANCE_LOG_DESCRIPTION: "El TS Expert detectó un posible exceso de terminadores o alta resistencia en el bus PROFIBUS.",
  A_NOT_OK_LOG_DESCRIPTION: "El TS Expert detectó posible cortocircuito entre el conductor A y la malla de blindaje, o la masa conectada a tierra de un panel o esclavo.",
  B_NOT_OK_LOG_DESCRIPTION: "El TS Expert detectó posible cortocircuito entre el conductor B y la malla de blindaje, o la masa conectada a tierra de un panel o esclavo.",
  LONG_CABLE_LOG_DESCRIPTION: "El TS Expert detectó una posible condición de bus con longitud mayor que la permitida.",
  NOISE_LOG_DESCRIPTION: "El TS Expert detectó una posible condición de ruido en la red PROFIBUS.",
  REFLECTION_LOG_DESCRIPTION: "El TS Expert detectó la presencia de reflexión en la forma de onda.",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: "El TS Expert detectó una posible falla en el nivel de tensión (Acción requerida).",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION: "El TS Expert detectó una posible falla en el nivel de tensión (Acción urgente).",
  FIBER_SIGNAL_LOSS_LOG_DESCRIPTION: "El TS Expert detectó una posible falla por relé.",
  EVENT_CHECKED_SUCCESS: "El evento se limpió con éxito.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME: "Informe TS Scope DP",
  HEADER_TEXT: "TS Scope DP",
  GENERATE_REPORT: "Generar informe",

  ANALYZER_VERSION_STRING: "- Versión de TS Scope DP:",
  ANALYZER_VERSION: "6.0.1",

  PROTOCOL: "- Protocolo:",
  PROTOCOL_TYPE: "PROFIBUS DP",

  ANALYSIS_INIT: "- Hora de inicio del análisis:",
  REPORT_GENERATION: "- Hora de generación del informe:",
  ANALYSIS_DURATION: "Duración del análisis hasta la generación del informe:",

  GENERAL_REPORT: "Informe general – TS Scope DP",
  DATA_REPORT: "Informe de datos – TS Scope DP",

  CLIENT_INFO: "Información del cliente",
  EXECUTING_COMPANY_INFO: "Información de la empresa ejecutora",
  CONFORMITY: "Conformidad",
  REPORT_TYPE: "Tipo de informe",
  ANNOTATIONS: "Anotaciones",
  CONCLUSION: "Conclusión",

  DROPDOWN_PLACEHOLDER: "Elija una opción",
  CONFORM: "Conforme",
  CONFORM_W_RESTRICTION: "Conforme con restricciones",
  NON_CONFORM: "No conforme",

  PROJECT_NAME: "- Nombre del proyecto:",
  NETWORK_NAME: "- Nombre de la red:",
  LOCATION: "- Ubicación:",
  COMPANY_NAME: "- Nombre de la empresa:",
  ACCOUNTABLE_NAME: "- Nombre del responsable:",
  COMPANY_ADDRESS: "- Dirección:",
  COMPANY_CITY: "- Ciudad:",
  COMPANY_TEL: "- Teléfono:",

  EXECUTING_COMPANY_NAME: "- Nombre de la empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nombre del responsable:",
  EXECUTING_TEL: "- Teléfono:",
  EXECUTING_EMAIL: "- Email:",

  SUMMARY: "Sumario",

  A_LIVE_LIST_PAGE_TITLE: "1. - Live List",
  A_OSCILLOSCOPE_PAGE_TITLE: "2. - Osciloscopio",
  A_BAR_GRAPH_PAGE_TITLE: "3. - Gráfico de barras",
  A_LOG_PAGE_TITLE: "4. - Log de eventos",

  ANALYSIS_INFO: "Información del análisis",
  GENERATED_BY: "- Generado por TS Scope DP",
  HARDWARE_VERSION: "- Versión de hardware:",
  SOFTWARE_VERSION: "- Versión de software:",
  DATE_TIME: "- Fecha y hora:",
  BAUD_RATE: "- Baud rate:",
  CYCLE_TIME: "- Tiempo de ciclo:",
  NUM_MASTERS: "- Maestros:",
  NUM_SLAVES: "- Esclavos:",
  AMPLITUDE_IDLE_1: "- Tensión en idle:",
  SEGMENT_TAG: "- Tag del segmento:",

  ETHERNET_INFO: "Información ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Gateway: ",

  NETWORK_NAME_DP: "- Nombre de la red: ",

  LIVE_LIST_DOTS: "........................................................................................................................................",
  BAR_DOTS: ".........................................................................................................................",
  OSC_DOTS: "................................................................................................................................",
  LOG_DOTS: "................................................................................................................................................",
  DISCLAIMER_DOTS: "....................................................................................................................................",

  GENERATING_REPORT_WAITING: "Generando informe; por favor, espere.",
  GENERATING_REPORT_WAITING_1: "Este procedimiento está tardando más de lo normal.",
  GENERATING_REPORT_WAITING_2: "Este procedimiento está tardando más de lo normal; por favor, siga esperando.",
  GENERATING_REPORT_SUCCESS: "Informe generado con éxito. Para guardarlo, haga clic en guardar informe abajo.",

  SELECT_REPORT_TYPE: "Por favor, seleccione un tipo de informe",

  MASTER_DP: "Maestro: ",
  SLAVE_DP: "Esclavo: ",
  SIGNAL_DP: "Señal: ",
  AMPLITUDE_DP: "Amplitud: ",
  AMPLITUDE_PRE_DP: "Amplitud del preámbulo: ",
  AMPLITUDE_MIN_DP: "Amplitud mínima: ",
  OVERSHOOTING_DP: "Sobreimpulso: ",
  AMPLITUDE_MAX_DP: "Amplitud máxima: ",
  MODEL: "Modelo",

  HORARY: "Horario",
  DESCRIPTION: "Descripción",
  GENERAL_INFORMATION: "Información general",
  LAST_200_EVENTS: "Últimos 200 eventos",

  END_OF_REPORT: "Fin del informe",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Los datos y valores presentados en este informe son meramente auxiliares para el especialista en PROFIBUS, de modo que cualquier indicación de corrección debe ser realizada por el usuario. Por esta razón, se recomienda el acompañamiento de un ingeniero certificado PROFIBUS o de un técnico responsable del análisis para validar la información proporcionada por el producto. Por lo tanto, Toledo & Souza se exime de cualquier responsabilidad, pérdida o daño, directo o indirecto, causado por las interpretaciones del software, y no ofrece ninguna garantía en relación con la integridad, calidad o adecuación de la información proporcionada, ya que depende del análisis técnico de un profesional capacitado. En ausencia de este, el usuario asumirá el riesgo de que el contenido pueda ser impreciso, incompleto o que no satisfaga sus necesidades y requisitos.",

  CAPTURE_TIME: "Hora de la captura",

  PROJECT_NAME_LABEL: "Nombre del proyecto",
  NETWORK_LABEL: "Nombre de la red",
  LOCATION_LABEL: "Ubicación",
  COMPANY_NAME_LABEL: "Nombre de la empresa",
  ACCOUNTABLE_NAME_LABEL: "Nombre del responsable",
  CITY_LABEL: "Ciudad",
  TEL_LABEL: "Teléfono",
  CLIENT_LOGO_LABEL: "Logo del cliente",
  EMAIL_LABEL: "E-mail",
  EXECUTING_COMPANY_LOGO_LABEL: "Logo de la empresa ejecutora",
  FINISHING: "Finalizando...",
  SAVE_REPORT: "Guardar informe",
  SLAVE_NOT_FOUND_SHOWING_LAST_WAVEFORM: "No fue posible encontrar el esclavo en la red; mostrando la última forma de onda capturada.",
  REPORT_SCOPE_DP: "Informe - TS Scope DP",
  MASTER: "Maestro ",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Entrar",
  LOGOUT: "Logout",
  TEST_NETWORK: "Red de prueba",
  TIMEZONE: "Timezone",
  RESTART_SYSTEM: "Reiniciar sistema",
  IP: "IP",
  MASK: "Máscara",
  GATEWAY: "Gateway",
  DNS: "DNS",
  TAG: "Tag",
  TAGS: "Tags",
  SETUP: "Configurar",
  EDIT: "Editar",
  SOFTWARE_UPDATE: "Actualización de software",
  INTERFACE_CONFIG: "Configuraciones de interfaz",
  CURRENT_VERSION: "Versión actual: ",
  UPDATE: "Actualizar",
  USER: "Usuario",
  NEW_PASSWORD: "Nueva contraseña",
  REPEAT_PASSWORD: "Repetir contraseña",
  ALTER_LOGIN: "Cambiar login",
  ARE_YOU_SURE_ALTER_CONFIG: "¿Está seguro de que desea cambiar las configuraciones Ethernet del TS Scope DP?",
  INVALID_OR_CORRUPT_FILE: "El archivo no es válido o está dañado.",
  IMPORT: "Importar",
  EXPORT: "Exportar",
  LOGIN_CREDENTIALS_FAILURE: "Se produjo un error al realizar el login: nombre de usuario o contraseña incorrectos.",
  LOGIN_GENERAL_FALIURE: "Se produjo un error al realizar el login:",

  GPG_ALERT_MESSAGE: "Solo es posible enviar archivos con extensión .gpg",
  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "El archivo se envió con éxito.",
  SEND_FILE_SUCCESS_WARNING: "No olvide verificar si la tarjeta de red de su computador está en la misma subred que la IP: ",
  SEND_FILE_FAILURE: "Se produjo un error al enviar el archivo.",
  SEND_FILE_WAITING: "Enviando el archivo.",
  SEND_FILE_WRONG_FILENAME: "Nombre inválido. El archivo de actualización debe llamarse: updateRMDP.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "El archivo de actualización se dañó durante el envío.",
  SEND_CONFIG_SUCCESS: "Las configuraciones se enviaron con éxito.",
  SEND_CONFIG_FAILURE: "Se produjo un error al enviar las configuraciones.",
  SEND_CONFIG_WAITING: "Enviando las configuraciones.",
  SEND_CONFIG_WAITING_2: "Finalizando el envío de las configuraciones.",
  SEND_CONFIG_DONE: "Configuraciones enviadas.",
  START_MESSAGE_SUCCESS: "El monitor se iniciará en 15 segundos.",
  START_MESSAGE_FAILURE: "Se produjo un error al iniciar el monitor.",
  STOP_MESSAGE_SUCCESS: "El monitor se detendrá en 15 segundos.",
  STOP_MESSAGE_FAILURE: "Se produjo un error al detener el monitor.",
  CLEAN_STATISTICS_SUCCESS: "Las estadísticas se limpiaron con éxito.",
  CLEAN_STATISTICS_FAILURE: "Se produjo un error al limpiar las estadísticas.",
  RESET_TRAFFIC_SUCCESS: "Los valores se pondrán en cero en el próximo escaneo.",
  RESET_TRAFFIC_FAILURE: "Se produjo un error al poner en cero los incrementos de error.",
  RESET_DEVICES_SUCCESS: "Los datos de devices se limpiaron con éxito.",
  RESET_DEVICES_FAILURE: "Se produjo un error al limpiar los datos de devices.",
  CHANGE_USERNAME_SUCCESS: "El nombre de usuario se cambió con éxito. Por favor, realice el login nuevamente.",
  CHANGE_USERNAME_FAILURE: "Se produjo un error al cambiar el nombre de usuario: ",
  USERNAME_TOO_SHORT: "El nombre de usuario debe contener al menos un carácter.",
  PASSWORD_MISSMATCH: "Las contraseñas ingresadas no coinciden",
  CHANGE_PASSWORD_SUCCESS: "La contraseña se cambió con éxito. Por favor, realice el login nuevamente.",
  CHANGE_PASSWORD_FAILURE: "Se produjo un error al cambiar la contraseña: ",
  RESET_RETRIES_SUCCESS: "Los reintentos se limpiaron con éxito.",
  RESET_RETRIES_FAILURE: "Se produjo un error al limpiar los reintentos.",

  VERIFY_THE_FOLLOWING_INFO: "Por favor, verifique la siguiente información:",
  INVALID_IP: "\n- La IP ingresada no es válida",
  INVALID_SUBMASK: "\n- La máscara ingresada no es válida",
  INVALID_GATEWAY: "\n- El gateway ingresado no es válido",
  INVALID_DNS: "\n- El DNS ingresado no es válido",
  LOOPBACK_IP: "\n- La IP de loopback (127.0.0.1) no puede utilizarse como IP del TS Scope DP",
  LOOPBACK_IP_NTP: "\n- La IP de loopback (127.0.0.1) no puede utilizarse como IP del servidor NTP",
  TAG_TOO_LONG: "\n- El tamaño de la tag no puede superar 30 caracteres",
  EMPTY_WIFI_PWD: "\n- La contraseña de Wi-Fi no puede estar vacía",
  SELECT_TIMEZONE: "\n- Es necesario seleccionar una Timezone para configurar el servidor NTP",
  SUBNET_OVERLAP_WLAN: "\n- TS Scope DP ha detectado que hay una superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no es posible configurar la WLAN con la dirección IP y mascarilla elegidas.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Scope DP ha detectado que hay una superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no es posible configurar la interfaz ETHERNET con la dirección IP y máscara elegidas.",
  ZERO_IP_MSG: "\n- La IP 0.0.0.0 no se puede utilizar como IP del TS Scope DP",
  ZERO_IP_MASK_MSG: "\n- La IP 0.0.0.0 no se puede utilizar como mascarilla de red",
  BROADCAST_IP_MSG: "\n- La IP de broadcast de la red no se puede utilizar como IP del TS Scope DP",
  NETWORK_IP_MSG: "\n- La IP de la red no se puede utilizar como IP del TS Scope DP",
  BROADCAST_GATEWAY_MSG: "\n- La IP de broadcast de la red no se puede utilizar como IP del gateway.",
  NETWORK_GATEWAY_MSG: "\n-La IP de red no se puede utilizar como IP del gateway",

  ALTER_USERNAME: "CAMBIAR USUARIO",
  ALTER_PASSWORD: "CAMBIAR CONTRASEÑA",

  SYSTEM: "Sistema",
  RESTART: "Reiniciar",
  CONFIRM_RESTART_SYSTEM: "¿Está seguro de que desea reiniciar el sistema?",
  RESTART_SYSTEM_FAILURE: "Se produjo un error al intentar reiniciar el sistema.",
  RESTART_SYSTEM_SUCCESS: "Solicitud de reinicio enviada con éxito. Espere cerca de 3 minutos para que el sistema se reinicie completamente.",

  SELECT_FILE: "Por favor, seleccione un archivo para enviar",
  SELECT_GSD_FLIE: "Por favor, seleccione al menos un archivo GSD para enviar",
  SENDING_GSD_FILES: "Enviando archivos GSD",

  DO_NOT_CLOSE_THIS_TAB: "Deje esta pestaña abierta para seguir la actualización.",
  UPDATING_MONITOR_FILES: "Actualizando archivos en el TS Scope DP. Por favor, espere.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Archivos actualizados; preparando para reiniciar el TS Scope DP.",
  RESTARTING_MONITOR_WAIT: "Reiniciando el TS Scope DP; espere unos minutos.",
  UPDATE_SUCCESS: "¡La actualización se realizó con éxito!",
  UPDATE_ERROR_STRING: "Se produjo el siguiente error al actualizar el TS Scope DP: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique al menos uno de los campos para actualizar las configuraciones de interfaz.",
  SCOPE_DP_IP_WAS_CHANGED_SUCCESSFULLY: "• La IP del TS Scope DP se cambió con éxito.",
  NOTE_WAS_CHANGED_SUCCESSFULLY: "• La observación se cambió con éxito.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRecuerde actualizar la dirección en el navegador a: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "¡Las configuraciones de interfaz se actualizaron con éxito!",

  ALTER: "Cambiar",
  NO: "No",
  YES: "Sí",

  NOTE: "Observación",
  MONITOR_IP: "IP del monitor",

  IN_SEGMENT_DEVICES: "Dispositivos del segmento",
  UPDATING_DATA: "Actualizando información, espere",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por dirección",

  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "Lista de dispositivos pertenecientes al mismo segmento que el TS Scope DP.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "Si el dispositivo está desmarcado en esta lista, significa que no pertenece al mismo segmento que el TS Scope DP.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "Si no pertenece al mismo segmento, la forma de onda vista en el osciloscopio puede no corresponder a la forma de onda real del dispositivo.",

  CONFIRM_ALTER_SEGMENT_DEVICES: "¿Está seguro de que desea realizar cambios en la lista de dispositivos pertenecientes al segmento?",

  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "Se produjo un error al cambiar la lista de dispositivos del segmento.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "¡La lista de dispositivos del segmento se cambió con éxito!",

  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / deshabilitar las no conformidades que serán informadas por la herramienta.",

  SEND_NTP_CONFIG_WAITING: "Enviando las configuraciones del servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configuraciones del servidor NTP enviadas.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Encender servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "¿Está seguro de que desea encender el servidor NTP? Para ello, será necesario reiniciar el TS Scope DP.",

  PROCESSING_NTP_INIT: "Iniciando el procesamiento de la información del servidor NTP",
  PROCESSING_NTP_INFO: "Procesando la información del servidor NTP.",
  PROCESSED_NTP_INFO: "Información del servidor NTP procesada.",
  PROCESSING_NTP_ERROR: "Se produjo un error al enviar la información al servidor NTP. Verifique si la dirección IP del servidor es correcta. Si lo es, verifique también si el servicio NTP está encendido e inténtelo nuevamente.",

  NTP_INFO_TURNED_ON_SUCCESS: "El servidor NTP se encendió con éxito.",
  NTP_INFO_TURNED_ON_FAILURE: "Se produjo un error al encender el servidor NTP.",
  NTP_INFO_FAILURE: "Error al sincronizar con el servidor. Si el error persiste, póngase en contacto con el administrador del servidor NTP.",
  TURN_ON_DATE: "\nLa hora del servidor se actualizó a: ",

  MONITOR_WILL_BE_RESTARTED: "\nEl TS Scope DP se reiniciará ahora,",
  MONITOR_RESTART_SUCCESS: "El TS Scope DP se reinició con éxito.",
  MONITOR_RESTART_FAILURE: "Se produjo un error al reiniciar el TS Scope DP.",

  NTP_INFO_TURNED_OFF_SUCCESS: "El servidor NTP se apagó con éxito.",
  NTP_INFO_TURNED_OFF_FAILURE: "Se produjo un error al apagar el servidor NTP.",
  TURN_OFF_DATE: "\nHora de apagado: ",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuración de la interfaz Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisión y acceso web a los datos del TS Scope DP.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuración de la interfaz inalámbrica, cuando hay adaptador disponible.",
  WLAN_POPUP_2: "Utilizado para supervisión y acceso web a los datos del TS Scope DP.",

  TAG_CONFIG: "Tag del segmento",

  TAG_WAS_CHANGED_SUCCESSFULLY: "La tag del TS Scope DP se cambió con éxito.",
  TAG_CHANGE_FAILURE: "Se produjo un error al cambiar la tag del TS Scope DP.",

  INVALID_MONITOR_IP: "La IP del monitor ingresada no es válida.",
  MONITOR_IP_WAS_CHANGED_SUCCESSFULLY: "La IP del monitor se cambió con éxito.",
  MONITOR_IP_CHANGE_FAILURE: "Se produjo un error al cambiar la IP del monitor.",

  WAITING: "Espere un instante",
  CLEAN_LOG_SUCCESS: "El log se limpió con éxito.",
  CLEAN_LOG_FAILURE: "Se produjo un error al limpiar el log.",
  CLEAR: "Limpiar",

  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "¿Está seguro de que desea cambiar el hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "Para ello es necesario reiniciar el monitor.",
  HOSTNAME_POPUP_1: "Un hostname debe tener entre 2 y 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Además, solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar únicamente con letras y números.",
  INVALID_HOSTNAME_1: "El hostname debe tener entre 2 y 64 caracteres.",
  INVALID_HOSTNAME_2: "El hostname solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar únicamente con letras y números.",
  HOSTNAME_CONFIG_SUCCESS: "El hostname se configuró con éxito.",
  HOSTNAME_CONFIG_ERROR: "Se produjo un error al configurar el hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID oculto",
  OPTIONAL: " (Opcional)",

  HOSTNAME: "Hostname",

  ALTER_MONITOR_WLAN_CONFIG: "¿Está seguro de que desea cambiar las configuraciones WLAN del TS Scope DP?",

  FIXED_IP: "IP fija",

  CHANGE_IDLE_SIZE: "Cambiar tamaño del idle",
  CHANGE_IDLE_SIZE_QUESTION_1: "Cambiar el tamaño del idle reiniciará los procedimientos internos del TS Monitor PROFIBUS PRO. Este procedimiento puede tardar hasta 3 minutos.",
  CHANGE_IDLE_SIZE_QUESTION_2: "Al hacer clic en sí, espere en la pantalla hasta finalizar. ¿Está seguro de que desea continuar?",

  CHANGE_PACKET_SIZE: "Cambiar tamaño de paquete",
  CHANGE_PACKET_SIZE_QUESTION_1: "Cambiar el tamaño de paquete reiniciará los procedimientos internos del TS Scope DP. Este procedimiento puede tardar hasta 3 minutos.",
  CHANGE_PACKET_SIZE_QUESTION_2: "Al hacer clic en sí, espere en la pantalla hasta finalizar. ¿Está seguro de que desea continuar?",

  ASK_PROCEED: "¿Está seguro de que desea continuar?",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Agregar/Cambiar tags",
  CHOOSE_DEVICE: "Elija un dispositivo",
  NEW_TAG: "Nueva TAG",
  REMOVE_ALL_TAGS: "Eliminar todas las tags",
  CONFIRM_REMOVE_ALL_TAGS: "¿Está seguro de que desea eliminar las tags de todos los dispositivos?",
  CHANGE_TAG_SUCCESS: "La tag se cambió con éxito.",
  CHANGE_TAG_FAILURE: "Se produjo un error al cambiar la tag",
  REMOVE_TAG_SUCCESS: "Las tags se eliminaron con éxito.",
  REMOVE_TAG_FAILURE: "Se produjo un error al eliminar las tags",
  IMPORT_TAGS_SUCCESS: "Las tags se importaron con éxito",
  IMPORT_TAGS_FAILURE: "Se produjo un error al importar las tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor, seleccione un archivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  SENDING_TS_EXPERT_CONFIG_WAITING: "Actualizando las configuraciones de TS Expert; espere un instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "Las configuraciones de TS Expert se guardaron con éxito.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Se produjo un error al guardar las configuraciones de TS Expert.",

  TS_EXPERT_CONFIGURATION: "Configuraciones de TS Expert",

  TERMINATION_OFF_LIST_HEADER: "Terminador en posición OFF",
  TERMINATION_OFF_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará una posible falta de terminador en la red.",

  NO_POWER_SUPPLY_LIST_HEADER: "Terminador sin alimentación",
  NO_POWER_SUPPLY_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible falta de alimentación en el terminador.",

  HIGH_RESISTANCE_LIST_HEADER: "Señal atenuada",
  HIGH_RESISTANCE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario un posible exceso de terminadores o alta resistencia en el bus PROFIBUS.",

  A_NOT_OK_LIST_HEADER: "Corto entre el conductor A y la malla",
  A_NOT_OK_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario un posible cortocircuito entre el conductor A y la malla de blindaje o la masa conectada a tierra de un panel o esclavo.",

  B_NOT_OK_LIST_HEADER: "Corto entre el conductor B y la malla",
  B_NOT_OK_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario un posible cortocircuito entre el conductor B y la malla de blindaje o la masa conectada a tierra de un panel o esclavo.",

  LONG_CABLE_LIST_HEADER: "Cable largo",
  LONG_CABLE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible condición de bus con longitud mayor que la permitida.",

  NOISE_LIST_HEADER: "Ruido o baja aislación (fuga a tierra)",
  NOISE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible condición de ruido en la red PROFIBUS.",

  REFLECTION_LIST_HEADER: "Reflexión en la forma de onda",
  REFLECTION_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará presencia de reflexión en la forma de onda.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER: "Link de fibra óptica – Falla en el nivel de tensión (Acción requerida)",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará baja tensión en las salidas analógicas que indican la calidad de la señal recibida por el link de fibra. Este valor puede ser configurado por el usuario en la pantalla de configuración de su TS Scope/Monitor PRO.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER: "Link de fibra óptica – Falla en el nivel de tensión (Acción urgente)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará baja tensión en las salidas analógicas que indican la calidad de la señal recibida por el link de fibra. Este valor puede ser configurado por el usuario en la pantalla de configuración de su TS Scope/Monitor PRO.",

  FIBER_SIGNAL_LOSS_LIST_HEADER: "Link de fibra óptica – Falla por relé",
  FIBER_SIGNAL_LOSS_LIST_CONTENT: "Cuando esta opción está activada, TS Expert mostrará falla en el link de fibra indicada por relé, que debe estar conectado al TS Scope/Monitor PRO.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT: "Lista de acciones",

  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de acciones - TS Expert - TS Scope DP",

  TS_EXPERT_POPUP_1: "En esta pestaña se presenta la información de TS Expert.",
  TS_EXPERT_POPUP_2: "Esta herramienta es un sistema experto desarrollado para optimizar y acelerar el análisis de las principales divergencias detectadas por TS Scope DP en redes PROFIBUS.",
  TS_EXPERT_POPUP_3: "De forma automatizada, mantenimiento, ingeniería y equipos relacionados pueden obtener una lista de acciones con diferentes eventos, sus posibles causas, sugerencias de solución y los dispositivos en los que fueron detectados.",
  TS_EXPERT_POPUP_4: "El uso de TS Expert no elimina la necesidad del análisis humano ni sustituye la capacidad de crear correlaciones de datos e interpretación.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detectado en: ",
  CHECK_YOUR_NETWORK: "Por favor, verifique su red.",

  EXPORT_ACTIONS_LIST: "Exportar lista de acciones",
  GENERATING_ACTIONS_LIST_WAITING: "Generando PDF de la lista de acciones; por favor, espere.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generado con éxito. Para guardarlo, haga clic en guardar lista de acciones.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Acciones",

  NO_PROBLEM_DETECTED: "TS Expert no detectó ningún evento en la red.",
  NO_EVENTS_TO_BE_ANALYZED: "No existen eventos para analizar.",

  NO_EVENT_SELECTED: "Ningún evento seleccionado",
  CHOOSE_AN_EVENT: "Elija un evento para visualizar las acciones sugeridas.",

  DETAILING: "Detalle",

  CHECKED: "Limpiar",
  BATCH_CHECK: "Limpiar todos",

  PROBLEM_CHECKED: "El evento se limpió con éxito",
  PROBLEM_CHECK_ERROR: "Se produjo un error al limpiar el evento.",

  QUANTITY_DP: "Cantidad: ",
  INCREMENTS: "Incrementos",

  PORT_IS_STILL_INACTIVE: "El puerto aún está inactivo",
  MARK_PROBLEM_AS_SOLVED: "¿Está seguro de que desea marcar el evento como limpio?",

  LAST_UPDATED: "Actualizado por última vez el: ",
  THIS_COMPUTER_TIME: " (Hora de este computador)",

  DEVICE: "Dispositivo",
  DEVICES: "Dispositivos",
  UNKNOWN: "Desconocido",

  // ---------------------------- TERMINADOR OFF ----------------------------
  TERMINATION_OFF_SUGGESTION_1: "Cuando el terminador esté en posición OFF, se sugiere:",
  TERMINATION_OFF_SUGGESTION_2: "Verificar visualmente:",
  TERMINATION_OFF_SUGGESTION_3: "Si los terminadores en ambos extremos del segmento están en posición \"on\";",
  TERMINATION_OFF_SUGGESTION_4: "Si no se utilizan conectores PROFIBUS, verificar si existe terminador activo en ambos extremos;",
  TERMINATION_OFF_SUGGESTION_5: "Si no existe terminador en uno de los extremos, es necesario realizar la instalación.",
  TERMINATION_OFF_SUGGESTION_6: "Se recomienda esperar una parada o programar con producción antes de encender el terminador apagado o instalar un terminador activo, ya que este cambio puede derribar la red.",

  // ---------------------------- NO POWER SUPPLY ----------------------------
  NO_POWER_SUPPLY_SUGGESTION_1: "Cuando el terminador esté sin alimentación, se sugiere:",
  NO_POWER_SUPPLY_SUGGESTION_2: "Verificar la alimentación de los terminadores activos (cuando tenemos instalado el dispositivo) y verificar la alimentación para terminadores en el esclavo o maestro en los pines del conector DB9, siendo:",
  NO_POWER_SUPPLY_SUGGESTION_3: "En el caso de terminador activo, basta con alimentarlo; pero en el caso de conector DB9, es necesario verificar si el problema está en el conector o en la alimentación proveniente del esclavo o maestro.",
  NO_POWER_SUPPLY_SUGGESTION_4: "Se recomienda realizar estos procedimientos con la producción detenida, ya que este cambio puede derribar la red.",

  // ---------------------------- HIGH RESISTANCE ----------------------------
  HIGH_RESISTANCE_SUGGESTION_1: "Cuando la señal esté atenuada, se sugiere:",
  HIGH_RESISTANCE_SUGGESTION_2: "Verificar:",

  HIGH_RESISTANCE_SUGGESTION_3: "Si algún equipo del segmento tiene el terminador interno encendido;",
  HIGH_RESISTANCE_SUGGESTION_4: "Si no hay ningún equipo con terminador interno encendido, verificar la electrónica de los esclavos, aislándolos individualmente del bus;",
  HIGH_RESISTANCE_SUGGESTION_5: "Verificar si existen bornes flojos en las conexiones por borne o conectores a borne;",
  HIGH_RESISTANCE_SUGGESTION_6: "Verificar mal contacto en conectores tipo “vampiro”;",
  HIGH_RESISTANCE_SUGGESTION_7: "Verificar si existen cables aplastados, lo que aumentaría la resistencia del cable.",

  HIGH_RESISTANCE_SUGGESTION_8: "Esta verificación puede realizarse con la red trabajando; sin embargo, para cualquier intervención se recomienda esperar una parada, ya que estos cambios pueden derribar la red.",

  // ---------------------------- A NOT OK ----------------------------
  A_NOT_OK_SUGGESTION_1: "Cuando haya corto entre el conductor A y la malla, se sugiere:",
  A_NOT_OK_SUGGESTION_2: "Realizar inspección visual:",
  A_NOT_OK_SUGGESTION_3: "Interna de los conectores, verificando si hay corto entre el conductor A y la malla;",
  A_NOT_OK_SUGGESTION_4: "En todo el segmento, verificando si hay algún tramo del cable dañado, prensado en bandeja portacables, cortado en salida de tubería o aplastado por cajón de CCM, etc.",

  // ---------------------------- B NOT OK ----------------------------
  B_NOT_OK_SUGGESTION_1: "Cuando haya corto entre el conductor B y la malla, se sugiere:",
  B_NOT_OK_SUGGESTION_2: "Realizar inspección visual:",
  B_NOT_OK_SUGGESTION_3: "Interna de los conectores, verificando si hay corto entre el conductor B y la malla;",
  B_NOT_OK_SUGGESTION_4: "En todo el segmento, verificando si hay algún tramo del cable dañado, prensado en bandeja portacables, cortado en salida de tubería o aplastado por cajón de CCM, etc.",

  // ---------------------------- LONG CABLE ----------------------------
  LONG_CABLE_SUGGESTION_1: "Cuando el cable sea muy largo, se sugiere:",
  LONG_CABLE_SUGGESTION_2: "Realizar una inspección visual del segmento y verificar si el bus es demasiado largo para el baud rate (tasa de comunicación), según la tabla de abajo.",
  LONG_CABLE_SUGGESTION_3: "Si el segmento es mayor que lo permitido, se sugiere insertar un repetidor o link de fibra óptica, dividiendo el segmento.",

  BAUD_RATE_: "Baud rate",
  LENGTH: "Longitud",
  NINE_SIX_KBITS: "9,6 kbit/s",
  NINETEEN_KBITS: "19,2 kbit/s",
  FORTY_FIVE_KBITS: "45,45 kbit/s",
  NINETY_THREE_KBITS: "93,75 kbit/s",
  HUN_EIGHTY_SEVEN_KBITS: "187,5 kbit/s",
  FIVE_HUNDRED_KBITS: "500,0 kbit/s",
  ONE_FIVE_KBITS: "1,5 Mbit/s",
  THREE_MBPS: "3,0 Mbit/s",
  SIX_MBPS: "6,0 Mbit/s",
  TWELVE_MBPS: "12,0 Mbit/s",

  // ---------------------------- NOISE ----------------------------
  NOISE_SUGGESTION_1: "Cuando haya ruido o baja aislación (fuga a tierra), se sugiere:",
  NOISE_SUGGESTION_2: "3 consejos tienden a ayudar a solucionar este problema:",
  NOISE_SUGGESTION_3: "Para atenuar el ruido, es necesario verificar si todos los esclavos de la red están debidamente conectados a tierra;",
  NOISE_SUGGESTION_4: "Es necesario verificar la equipotencialización del sistema de puesta a tierra; una forma simple es verificar si hay corriente de fuga en los cables PROFIBUS. Se espera un valor por debajo de 100mA;",
  NOISE_SUGGESTION_5: "Verificar el aislamiento de las interfaces de los esclavos; una forma simple es desconectar uno a uno los esclavos del segmento y verificar en el TS Scope si el problema persiste, es decir, si en la Live List las señales se estabilizan en BUENO).",
  NOISE_SUGGESTION_6: "Si el problema persiste después de estos consejos, recomendamos buscar un especialista en redes PROFIBUS.",

  // ---------------------------- REFLECTION ----------------------------
  REFLECTION_SUGGESTION_1: "Cuando haya reflexión en la forma de onda, se sugiere:",
  REFLECTION_SUGGESTION_2: "Este evento casi siempre está asociado a falta de terminación en la red; por lo tanto, debe verificarse visualmente:",

  REFLECTION_SUGGESTION_3: "Si los terminadores en ambos extremos del segmento están en posición “on”;",
  REFLECTION_SUGGESTION_4: "Si no se utilizan conectores PROFIBUS, verificar si existe terminador activo en ambos extremos;",
  REFLECTION_SUGGESTION_5: "Si no existe terminador en uno de los extremos, es necesario realizar la instalación.",

  REFLECTION_SUGGESTION_6: "Sin embargo, la reflexión también puede ser resultado de empalme en el cable, uso de bornes inadecuados, cables aplastados, cambio de tipo de cable, uso de empalme con M12 o cualquier otro cambio en el medio físico de comunicación.",
  REFLECTION_SUGGESTION_7: "En estos casos, se hace necesaria una inspección visual detallada en el segmento de red indicado.",

  VOLTAGE_: "Tensión",

  // ---------------------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED ----------------------------

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1: "Cuando se detecte un link de fibra óptica con falla en el nivel de tensión, se sugiere verificar visualmente:",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2: "La alimentación del link de fibra;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3: "Verificar las conexiones de fibra y cobre;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5: "Se sugiere consultar el manual del fabricante del enlace de fibra para verificar el nivel de tensión adecuado.",

  // ---------------------------- FIBER LOWER LIMIT URGENT MAINTENANCE ----------------------------

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1: "Cuando se detecte un link de fibra óptica con una falla grave en el nivel de tensión, se sugiere verificar visualmente:",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2: "La alimentación del link de fibra;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3: "Verificar las conexiones de fibra y cobre;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5: "Se sugiere consultar el manual del fabricante del enlace de fibra para verificar el nivel de tensión adecuado.",

  // ---------------------------- FIBER SIGNAL LOSS ----------------------------
  FIBER_SIGNAL_LOSS_SUGGESTION_1: "Cuando se detecte una señal de falla por relé en el link de fibra óptica, se sugiere verificar visualmente:",
  
  FIBER_SIGNAL_LOSS_SUGGESTION_2: "La alimentación del link de fibra;",
  FIBER_SIGNAL_LOSS_SUGGESTION_3: "Verificar las conexiones de fibra y cobre;",
  FIBER_SIGNAL_LOSS_SUGGESTION_4: "Verificar la condición de las fibras ópticas.",

  // ---------------------------- EXPERT REPORT ----------------------------
  SAVE_ACTIONS_LIST: "Guardar lista de acciones",
  ACTIONS_LIST_FILENAME_PART: "Lista de acciones - TS Scope DP",

  TERMINATION_OFF_PAGE_TITLE: ". - Terminador en posición OFF",
  NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE: ". - Terminador sin alimentación",
  HIGH_RESISTANCE_PAGE_TITLE: ". - Señal atenuada",
  A_NOT_OK_PAGE_TITLE: ". - Corto entre el conductor A y la malla",
  B_NOT_OK_PAGE_TITLE: ". - Corto entre el conductor B y la malla",
  LONG_CABLE_PAGE_TITLE: ". - Cable largo",
  NOISE_PAGE_TITLE: ". - Ruido o baja aislación (fuga a tierra)",
  REFLECTION_PAGE_TITLE: ". - Reflexión en la forma de onda",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE: ". - Link de fibra óptica – Falla en el nivel de tensión (Acción requerida)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE: ". - Link de fibra óptica – Falla en el nivel de tensión (Acción urgente)",
  FIBER_SIGNAL_LOSS_PAGE_TITLE: ". - Link de fibra óptica – Falla por relé",

  TERMINATION_OFF_DOTS: "............................................................................................................",
  NO_POWER_SUPPLY_DOTS: "....................................................................................................",
  HIGH_RESISTANCE_DOTS: "............................................................................................................................",
  A_NOT_OK_DOTS: "...........................................................................................",
  B_NOT_OK_DOTS: "...........................................................................................",
  LONG_CABLE_DOTS: "..................................................................................................................................",
  NOISE_DOTS: ".................................................................................",
  REFLECTION_DOTS: "......................................................................................................",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS: "............................................",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS: "...............................................",
  FIBER_SIGNAL_LOSS_DOTS: "..................................................................................................",

  DISCLAIMER_EXPERT_DOTS: ".......................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: ".........................................................................................................................................",

  SUGGESTION: "Se sugiere",
  EVIDENCE: "Evidencias",
  EVIDENCE_SINGULAR: "Evidencia",
  EVIDENCE_DESCRIPTION: "Captura de evidencia de la no conformidad informada por TS Expert:",

  TERMINATION_OFF_PAGE_DESCRIPTION: "TS Expert está indicando una posible falta de terminador en la red.",
  NO_POWER_SUPPLY_PAGE_DESCRIPTION: "TS Expert está indicando una posible falta de alimentación en el terminador.",
  HIGH_RESISTANCE_PAGE_DESCRIPTION: "TS Expert está indicando posible exceso de terminadores o alta resistencia en el bus PROFIBUS.",
  A_NOT_OK_PAGE_DESCRIPTION: "TS Expert está indicando posible cortocircuito entre el conductor A y la malla de blindaje o la masa conectada a tierra de un panel o esclavo.",
  B_NOT_OK_PAGE_DESCRIPTION: "TS Expert está indicando posible cortocircuito entre el conductor B y la malla de blindaje o la masa conectada a tierra de un panel o esclavo.",
  LONG_CABLE_PAGE_DESCRIPTION: "TS Expert está indicando posible condición de bus con longitud mayor que la permitida.",
  NOISE_PAGE_DESCRIPTION: "TS Expert está indicando posible condición de ruido en la red PROFIBUS.",
  REFLECTION_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de reflexión en la forma de onda.",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de link de fibra óptica con falla en el nivel de tensión.",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de link de fibra óptica con falla en el nivel de tensión.",
  FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de link de fibra óptica con falla por relé",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configuraciones WLAN",
  CONNECTION_STATUS: "Estado de la conexión",

  WLAN_ADAPTER_ON: "Encendido",
  WLAN_ADAPTER_OFF: "Apagado",

  IP_PLACEHODLER: "192.168.2.210",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Intensidad de señal",
  FREQUENCY: "Frecuencia",
  CHANNEL: "Canal",
  QUALITY: "Calidad",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Calidad",

  TURNING_WLAN_OFF_WAITING: "Apagando el adaptador WLAN; por favor, espere.",
  TURNING_WLAN_ON_WAITING: "Encendiendo el adaptador WLAN; por favor, espere.",

  NETWORK: "Red",
  NETWORK_NAME_1: "Nombre de la red",
  SUBMASK: "Máscara",
  PASSWORD: "Contraseña",

  ALTER_SCOPE_WLAN_CONFIG: "¿Está seguro de que desea cambiar las configuraciones WLAN del TS Scope DP?",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica el estado del adaptador WLAN del TS Scope DP.",
  WLAN_STATUS_POPUP_2: "Si está apagado, no es posible cambiar las configuraciones WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica si el TS Scope DP está conectado o no a la red WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "No es posible cambiar las configuraciones mientras el adaptador WLAN esté apagado.",
  WLAN_CONFIG_POPUP_2: "Se recomienda encarecidamente que las configuraciones WLAN se cambien solo al acceder al TS Scope DP por medio de la red cableada.",
  WLAN_CONFIG_POPUP_3: "Al cambiar la IP / máscara, si los campos aparecen en blanco después de la actualización, esto es un fuerte indicio de que:",
  WLAN_CONFIG_POPUP_4: "Ya existe otro dispositivo en la red con la misma IP;",
  WLAN_CONFIG_POPUP_5: "La máscara de red es muy restrictiva y no admite la IP que se ingresó.",

  WLAN_ADAPTER_NOT_FOUND_1: "El TS Scope DP no logró encontrar el adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique si el adaptador está desconectado o con mal contacto;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Si el adaptador no está desconectado ni con mal contacto, intente sustituirlo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Si ninguna de las opciones anteriores soluciona el problema, póngase en contacto con Toledo e Souza.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique al menos uno de los campos para actualizar las configuraciones WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "¡Las configuraciones WLAN se actualizaron con éxito!",
  SEND_WLAN_CONFIG_WAITING: "Enviando las configuraciones; por favor, espere. Esto puede tardar cerca de un minuto.",
  LOADING_WAITING: "Cargando información; por favor, espere.",
  WLAN_INFO: "Información WLAN",
  MAC: "MAC",

  UPDATE_WLAN_CONFIG_ERROR: "No fue posible conectarse a la red WLAN. Si el problema persiste, intente reiniciar el TS Scope DP o el router WLAN.",

  // ---------------------------- Temperature Alert ----------------------------
  IDLE_SIZE: "Tamaño del idle",
  PACKET_SIZE: "Tamaño de paquete",

  SMALL: "Pequeño",
  MEDIUM: "Medio",
  BIG: "Grande",

  IDLE_SIZE_QUESTION_ICON_INFO: "El tamaño del idle se refiere a la cantidad de puntos considerados al comienzo de la forma de onda de la respuesta del device. Es posible configurar tres tamaños distintos:",
  IDLE_SIZE_QUESTION_ICON_INFO_1: "Tamaño del idle estándar (varía de acuerdo con el baud rate);",
  IDLE_SIZE_QUESTION_ICON_INFO_2: "Aumenta el tamaño en 1 tiempo de un bit;",
  IDLE_SIZE_QUESTION_ICON_INFO_3: "Aumenta el tamaño en 2 tiempos de un bit.",

  PACKET_SIZE_QUESTION_ICON_INFO: "El tamaño de paquete es la cantidad total de puntos capturados por el TS Scope DP en un único paquete de datos. Es posible configurar tres tamaños distintos:",
  PACKET_SIZE_QUESTION_ICON_INFO_1: "Tamaño de paquete estándar (varía de acuerdo con el baud rate);",
  PACKET_SIZE_QUESTION_ICON_INFO_2: "Aumenta el tamaño de paquete en 100 puntos;",
  PACKET_SIZE_QUESTION_ICON_INFO_3: "Aumenta el tamaño de paquete en 200 puntos.",

  IDLE_SIZE_WAITING: "Realizando procedimientos para cambiar el tamaño del idle; por favor, espere en esta pantalla hasta que terminen.",
  IDLE_SIZE_WAS_CHANGED_SUCCESSFULLY: "El tamaño del idle se cambió con éxito",
  IDLE_SIZE_CHANGE_FAILURE: "Se produjo un error al cambiar el tamaño del idle.",

  PACKET_SIZE_WAITING: "Realizando procedimientos para cambiar el tamaño del paquete; por favor, espere en esta pantalla hasta que terminen.",
  PACKET_SIZE_WAS_CHANGED_SUCCESSFULLY: "El tamaño de paquete se cambió con éxito",
  PACKET_SIZE_CHANGE_FAILURE: "Se produjo un error al cambiar el tamaño del paquete.",

  REASON_DP: "Motivo: ",

  // ---------------------------- Segment Devices ----------------------------
  CHECK_MASTER: "Verificar maestro",
  START_SEARCH_ERROR_MESSAGE: "Se produjo un error al iniciar la búsqueda de dispositivos. Por favor, inténtelo nuevamente.",
  SEARCH_FINISH_SUCCESS: "¡Búsqueda de dispositivos finalizada con éxito!",
  GET_DEVICES_LIST_ERROR: "Se produjo un error al cargar la lista de dispositivos.",

  IN_SEGMENT: "Actualmente en el segmento",
  POSSIBLY_IN_SEGMENT: "Identificado como perteneciente",
  POSSIBLY_OUT_OF_SEGMENT: "Se detectó que este dispositivo puede estar en otro segmento",

  SEND_SEGMENT_DEVICES_INFO_SUCCESS: "¡La información sobre los dispositivos del segmento se envió con éxito!",
  SEND_SEGMENT_DEVICES_INFO_ERROR: "Se produjo un error al enviar la información sobre los dispositivos del segmento.",

  SEARCH: "Buscar",
  SEARCH_POPUP_1: "Para utilizar el TS Scope DP por primera vez, se recomienda seleccionar qué dispositivos pertenecen al segmento.",
  SEARCH_POPUP_2: "Presione el botón de abajo para que el TS Scope DP realice una búsqueda y encuentre todos los dispositivos alcanzables en la red.",
  SEARCH_POPUP_3_1: "Después de encontrar los dispositivos, el TS Scope DP los agregará a la lista de ",
  SEARCH_POPUP_3_2: "dispositivos disponibles",
  SEARCH_POPUP_3_3: " al lado. Los dispositivos disponibles ",
  SEARCH_POPUP_3_4: "son todos aquellos encontrados, pertenezcan o no al segmento de red actual.",
  SEARCH_POPUP_4_1: "La otra lista, de ",
  SEARCH_POPUP_4_2: "dispositivos seleccionados",
  SEARCH_POPUP_4_3: ", es la lista que ",
  SEARCH_POPUP_4_4: "contiene los dispositivos seleccionados por el usuario que tiene certeza de que están en el segmento de red actual.",
  SEARCH_POPUP_4_5: " Inicialmente, esta lista estará vacía.",
  SEARCH_POPUP_5: "Una vez realizada la búsqueda, corresponde al usuario seleccionar cuáles de estos dispositivos realmente pertenecen al segmento de red, moviéndolos de la lista de dispositivos disponibles a la lista de dispositivos seleccionados.",
  SEARCH_POPUP_6_1: "OBS: ",
  SEARCH_POPUP_6_2: "Los maestros de la red siempre son monitoreados por el TS Scope DP; por lo tanto, no aparecen en esta página.",

  SAVE_POPUP_1_1: "Al hacer clic en el botón de abajo, se guardarán los dispositivos que estén en la lista ",
  SAVE_POPUP_1_2: "Dispositivos seleccionados",
  SAVE_POPUP_1_3: ".",
  SAVE_POPUP_2_1: "Al realizar este procedimiento, solo los dispositivos de la lista ",
  SAVE_POPUP_2_2: "Dispositivos seleccionados",
  SAVE_POPUP_2_3: " serán monitoreados por el TS Scope DP, y ",
  SAVE_POPUP_2_4: "solo ellos se mostrarán en las pantallas del TS Scope DP, como: Live List, Matriz, Osciloscopio, etc.",

  EXPLANATION: "Explicación",

  SAVE_POPUP_3: "Esta funcionalidad es importante para identificar los esclavos pertenecientes al segmento de red PROFIBUS. Esto reduce el tiempo de respuesta, ya que el sistema estará verificando los esclavos pertinentes.",
  SAVE_POPUP_4: "También es de gran utilidad para que quienes tengan menor conocimiento de la red no busquen el problema en un segmento equivocado.",

  AVAILABLE_DEVICES: "Dispositivos disponibles",
  AVAILABLE_DEVICES_POPUP_1_1: "Esta lista contiene todos los dispositivos que el TS Scope DP ",
  AVAILABLE_DEVICES_POPUP_1_2: "encontró en la red.",
  AVAILABLE_DEVICES_POPUP_2: "El TS Scope DP sugiere los dispositivos que cree que pertenecen al segmento de red actual, indicándolos como: ",
  AVAILABLE_DEVICES_POPUP_2_1: " Identificado como perteneciente.",

  AVAILABLE_DEVICES_POPUP_3_1: "Hacer clic en el botón ",
  AVAILABLE_DEVICES_POPUP_3_2: " mueve un dispositivo de la lista de ",
  AVAILABLE_DEVICES_POPUP_3_3: "dispositivos disponibles",
  AVAILABLE_DEVICES_POPUP_3_4: " a la lista de ",
  AVAILABLE_DEVICES_POPUP_3_5: "dispositivos seleccionados",
  AVAILABLE_DEVICES_POPUP_3_6: ", indicando que pertenece al segmento actual de la red. Después de mover los dispositivos, es necesario hacer clic en el botón ",
  AVAILABLE_DEVICES_POPUP_3_7: "Guardar",
  AVAILABLE_DEVICES_POPUP_3_8: " para guardar estos cambios.",

  AVAILABLE_DEVICES_POPUP_4_1: "OBS: ",
  AVAILABLE_DEVICES_POPUP_4_2: "Queda a cargo del usuario tomar la decisión final y decidir qué dispositivos realmente pertenecen al segmento.",

  LOADING_DEVICES: "Cargando dispositivos",

  MOVE_ALL: "Mover todos",

  SELECTED_DEVICES: "Dispositivos seleccionados",

  SELECTED_DEVICES_POPUP_1_1: "Esta lista contiene todos los dispositivos que el usuario marcó como ",
  SELECTED_DEVICES_POPUP_1_2: "pertenecientes al segmento de red actual.",

  SELECTED_DEVICES_POPUP_2_1: "Es importante destacar que, después de hacer clic en el botón ",
  SELECTED_DEVICES_POPUP_2_2: "Guardar",
  SELECTED_DEVICES_POPUP_2_3: ", el TS Scope DP ",
  SELECTED_DEVICES_POPUP_2_4: "solo monitoreará los dispositivos que estén en la lista de dispositivos seleccionados.",

  SELECTED_DEVICES_POPUP_3_1: "Esto significa que:",
  SELECTED_DEVICES_POPUP_3_2: " Los dispositivos que no estén en esta lista no se mostrarán en las pantallas de Live List, Matriz, Osciloscopio, Gráfico de barras, etc.",

  CONFIRM_SEARCH_START: "¿Está seguro de que desea iniciar la búsqueda?",

  CONFIRM_SEARCH_START_POPUP_1_1: "El procedimiento de búsqueda de dispositivos tardará ",
  CONFIRM_SEARCH_START_POPUP_1_2: "5 (cinco) minutos",
  CONFIRM_SEARCH_START_POPUP_1_3: " en completarse.",

  CONFIRM_SEARCH_START_POPUP_2_1: " Durante la búsqueda ",
  CONFIRM_SEARCH_START_POPUP_2_2: "se reiniciarán diversos procedimientos internos del TS Scope DP",
  CONFIRM_SEARCH_START_POPUP_2_3: ", y por esta razón, solo volverá a funcionar normalmente después de que finalice la búsqueda.",
  CONFIRM_SEARCH_START_POPUP_2_4: "OBS:",

  SEARCHING_DEVICES: "Buscando dispositivos.",
  PLEASE_STAY_IN_PAGE: "Por favor, permanezca en la página para seguir el progreso de la búsqueda.",

  SENDING_DEVICES_INFO: "Enviando información sobre los dispositivos, espere.",

  // ---------------------------- ACTIVE CHANNELS ----------------------------
  ACTIVE_CHANNELS: "Canales activos",
  ACTIVE_CHANNELS_POPUP_1: "Permite configurar qué canales del TS Scope DP están activos en este momento (qué canales se utilizarán).",
  ACTIVE_CHANNELS_POPUP_2: "Se recomienda desactivar todos los canales que no se estén utilizando en este momento.",
  SAVING_ACTIVE_CHANNELS: "Guardando canales activos; por favor, espere.",
  SEND_ACTIVE_CHANNELS_SUCCESS: "¡Los canales activos se guardaron con éxito!",
  SEND_ACTIVE_CHANNELS_ERROR: "Se produjo un error al guardar los canales activos",
  CANT_TURN_ALL_CHANNELS_OFF: "No es posible desactivar todos los canales del TS Scope DP al mismo tiempo.\n\nEs necesario que al menos uno de los canales permanezca activo.",

  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",
  CHANNEL_5: "Canal 5",

  // ---------------------------- CHANNELS TIME ----------------------------
  CHANNELS_TIME: "Intervalo de escucha de los canales",
  CHANNEL_TIME_PLACEHOLDER: "20",
  CHANNELS_TIME_POPUP_1: "En esta sección es posible configurar cada cuántos minutos el TS Scope DP escuchará el intercambio de datos en cada uno de los canales.",
  CHANNELS_TIME_POPUP_2: "Solo son válidos intervalos entre los siguientes valores:",
  CHANNELS_TIME_POPUP_3: "El intervalo mínimo de escucha es de ",
  CHANNELS_TIME_POPUP_4: "El intervalo máximo de escucha es de ",
  CHANNELS_TIME_POPUP_5: "(1 hora).",

  CONFIGURE_CHANNELS_TIME_SUCCESS: "¡El intervalo de escucha de los canales se configuró con éxito!",
  CONFIGURE_CHANNELS_TIME_ERROR: "Se produjo un error al enviar el intervalo de escucha de los canales.",
  ERROR_REASON: ".\nMotivo: ",

  ERROR_MSG_1: "El intervalo de escucha del",
  ERROR_MSG_2: "no es válido.",

  //
  DEVICE_CHANNELS_ON: "Encendida",
  DEVICE_CHANNELS_OFF: "Apagada",

  CHANNELS_AND_DEVICES: "Canales y dispositivos",
  DEVICE_CHANNELS_POPUP: "En esta sección es posible configurar si el TS Scope DP descubrirá automáticamente a qué canal pertenece cada dispositivo, o si el usuario desea definir manualmente el canal de cada dispositivo.",

  MEASURE_UNIT: "min",
  MEASURE_UNIT_1: "minuto",
  MEASURE_UNIT_2: "minutos",

  // ---------------------------- DEVICE CHANNELS ----------------------------
  CHECK_MASTER_2: "Verificar maestro",
  CHECK_MASTER_POPUP: "Al encender la verificación del maestro, el TS Scope DP detectará automáticamente quién es el maestro de este segmento de la red.",

  CHANGE_MANUAL_SELECTION_QUESTION_1: "Cambiar el estado de la selección de canales reiniciará los procedimientos internos del TS Scope DP. Este procedimiento puede tardar hasta 3 minutos.",
  CHANGE_MANUAL_SELECTION_QUESTION_2: "Al hacer clic en sí, espere en la pantalla hasta finalizar. ¿Está seguro de que desea continuar?",

  CHANGE_VERIFY_MASTER_QUESTION_1: "Cambiar la verificación del maestro reiniciará los procedimientos internos del TS Scope DP. Este procedimiento puede tardar hasta 3 minutos.",
  CHANGE_VERIFY_MASTER_QUESTION_2: "Al hacer clic en sí, espere en la pantalla hasta finalizar. ¿Está seguro de que desea continuar?",

  CHANGE_DEVICES_CHANNEL_QUESTION_1: "Actualizar los canales de los dispositivos reiniciará los procedimientos internos del TS Scope DP. Este procedimiento puede tardar hasta 3 minutos.",
  CHANGE_DEVICES_CHANNEL_QUESTION_2: "Al hacer clic en sí, espere en la pantalla hasta finalizar. ¿Está seguro de que desea continuar?",

  MANUAL_CHANNEL_SELECTION: "Selección manual de canales",
  MANUAL_CHANNEL_SELECTION_1: "Selección manual",
  MANUAL_CHANNEL_SELECTION_2: "de canales",

  MANUAL_CHANNEL_SELECTION_POPUP_1: "Al encender la selección manual, el usuario podrá elegir en la tabla de al lado a qué canal pertenece cada dispositivo.",
  MANUAL_CHANNEL_SELECTION_POPUP_2: "Al apagar la selección manual, el TS Scope DP intentará descubrir automáticamente a qué canal pertenece cada dispositivo.",
  MANUAL_CHANNEL_SELECTION_POPUP_3: "El descubrimiento automático de canales solo es 100% confiable si se utiliza el TS Hub de Toledo e Souza. Si se utiliza otro hub, se recomienda definir manualmente el canal de cada dispositivo.",

  ALTER_DEVICES_CHANNELS: "Actualizar canales de los dispositivos",

  WARNING: "Aviso",
  MANUAL_SELECTION_WARNING_MESSAGE: "Mientras la selección manual esté apagada, las opciones de al lado estarán inaccesibles.",
  RESTARTING_INTERNAL_PROCEDURES: "Reiniciando procedimientos internos; por favor, espere.",
  SEND_CHANGES_FAILURE: "Se produjo un error al enviar los cambios",

  DEVICES_PER_CHANNEL_POST_SUCCESS: "¡Los dispositivos y sus canales se guardaron con éxito!",
  DEVICES_PER_CHANNEL_ON_POST_SUCCESS: "¡La selección manual de dispositivos del canal se cambió con éxito!",
  VERIFY_MASTER_POST_SUCCESS: "¡La verificación del maestro se cambió con éxito!",

  DEVICES_PER_CHANNEL_POST_ERROR: "Se produjo un error al enviar los dispositivos y canales.",
  DEVICES_PER_CHANNEL_ON_POST_ERROR: "Se produjo un error al cambiar la selección manual de canales.",
  VERIFY_MASTER_POST_ERROR: "Se produjo un error al cambiar la verificación del maestro.",

  // ---------------------------- OPTIC FIBER ----------------------------
  OPTIC_FIBER: "Fibra óptica",
  RELAY_STATUS: "Estado del relé",
  RELAY_SIGNAL: "Señal del relé",
  MIN: "Mínimo",
  MAX: "Máximo",
  FAULT: "Falla",
  OK: "OK",
  MIN_ANALOG_VALUE: "Valor mínimo analógico",
  MIN_LIMIT_NOT_VALID: "El valor mínimo analógico no es válido",
  STATUS: "Status",
  MAINTENANCE_URGENT: "Valor de mantenimiento urgente",
  MAINTENANCE_REQUIRED: "Valor de mantenimiento requerido",
  DIVERGENCE_MAINTENANCE_VALUE: "¡El valor de mantenimiento requerido no puede ser menor que el de mantenimiento urgente!",
  INVALID_VALUE: "Valor inválido",
  STR_LIMIT: "Hasta",

  // ---------------------------- LANGUAGE ----------------------------
  PORTUGUESE: "Portugués",
  ENGLISH: "Inglés",
  SPANISH: "Español",
  GERMAN: "Alemán",
  UPDATING_LANGUAGE_WAITING: "Cambiando el idioma, espere un momento",
  UNABLE_TO_ALTER_LANGUAGE: "No fue posible cambiar el idioma del programa.\n",

  UPDATES_SUCCESS: "Actualizaciones realizadas con éxito",

  IP_ASSOCIATED_MONITOR: "Dirección IP del monitor asociado: ",
  PHYS_MEDIUM: "Capa física DP",
});